export default "__VITE_ASSET__Ckgpf_GQ__"